import { render, staticRenderFns } from "./WPButtonAddList.vue?vue&type=template&id=3dbb6d52"
import script from "./WPButtonAddList.vue?vue&type=script&lang=ts"
export * from "./WPButtonAddList.vue?vue&type=script&lang=ts"
import style0 from "./WPButtonAddList.vue?vue&type=style&index=0&id=3dbb6d52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports